function tabs() {
    let tabSection = document.querySelectorAll(".section-with-tabs");

    for (let s = 0; s < tabSection.length; s++) {
        let tab = tabSection[s].querySelectorAll(".tab");
        let tabContent = tabSection[s].querySelectorAll(".tab-content");

        if (!tab.length && !tabContent.length) continue;

        for (let i = 0; i < tab.length; i++) {
            tab[i].addEventListener("click", function (e) {
                e.preventDefault();
                tab.forEach((t) => {
                    t.classList.remove("active");
                });

                tabContent.forEach((tc) => {
                    tc.classList.remove("active");
                });

                tabContent[i].classList.add("active");
                tab[i].classList.add("active");

                centerActiveTab(tab[i]);
            });
        }
    }
}

tabs();
